import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

import { map, take } from 'rxjs/operators';

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userData.pipe(
    take(1),
    map(user => {
      if (user && !user.isAnonymous) {
        return router.createUrlTree(['/loads']);
      }
      return true;
    })
  );
};
